import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import * as TaskFolderActions from './task-folder.actions';
import { TaskFolderService } from '../../../shared/service/task-folder/task-folder.service';
import { from, of, switchMap } from 'rxjs';
import { BaseOneResponseInterface } from '../../../shared/model/interface/crud-response-interface.model';
import { catchError } from 'rxjs/operators';
import {
  IRawTreeItem,
  ITaskFolderFilterActivityMap,
  ITaskFolderFilterResponse,
} from '../../../shared/component/filter/task-folder-filter/task-folder-filter.model';
import { EntityTranslatorService } from '../../../shared/service/entity-translator/entity-translator.service';

@Injectable()
export class TaskFolderEffects {
  constructor(
    private readonly actions$: Actions<TaskFolderActions.TaskFolderActions>,
    private readonly taskFolderService: TaskFolderService,
    private readonly entityTranslatorService: EntityTranslatorService,
  ) {}

  getTaskFolderData = createEffect(() =>
    this.actions$.pipe(
      ofType(TaskFolderActions.ActionTypes.GetTaskFolders),
      switchMap((actionPayload: TaskFolderActions.GetTaskFolders) => {
        return from(this.taskFolderService.getTaskFolderFilter(actionPayload.params)).pipe(
          switchMap((response: BaseOneResponseInterface<ITaskFolderFilterResponse>) => {
            response.data.treeNodes.forEach((row: IRawTreeItem) => {
              this.entityTranslatorService.translate(row);
            });

            Object.values(response.data.activityMap).forEach((activity: ITaskFolderFilterActivityMap) => {
              this.entityTranslatorService.translate(activity);
            });

            return of(new TaskFolderActions.GetTaskFoldersLoaded(response.data));
          }),
          catchError(() => {
            return of(new TaskFolderActions.FetchError(TaskFolderActions.ActionTypes.GetTaskFolders));
          }),
        );
      }),
    ),
  );
}
